// Insphirea chrome: scroll reveals + dispatch countdown.
(function () {
  const els = [...document.querySelectorAll(".ins-reveal")];
  if (els.length) {
    if (!("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("in")); }
    else {
      const io = new IntersectionObserver(
        (ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }),
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      els.forEach((e) => io.observe(e));
    }
  }

  const el = document.querySelector("[data-ins-cutoff]");
  if (el) {
    const tick = () => {
      const now = new Date();
      const cutoff = new Date(now); cutoff.setHours(13, 0, 0, 0);
      const T = (window.INS_I18N && window.INS_I18N.announce) || {};
      if (now < cutoff) {
        const ms = cutoff - now;
        const h = Math.floor(ms / 3.6e6), m = Math.floor((ms % 3.6e6) / 6e4);
        const tmpl = T.countdown || "Nog [h]u [m]m voor verzending vandaag";
        el.textContent = tmpl.replace("[h]", h).replace("[m]", m);
      } else { el.textContent = T.ordered_shipped || "Vandaag besteld, morgen verzonden"; }
    };
    tick(); setInterval(tick, 60000);
  }
})();

// Prefetch product/collection pages on intent (hover/touchstart) so navigation
// feels near-instant. Low-priority, deduped, same-origin only. Pairs with the
// CSS view-transition for a smooth, flash-free page change. Respects Save-Data.
(function () {
  if (navigator.connection && navigator.connection.saveData) return;
  const seen = new Set();
  function prefetch(href) {
    if (seen.has(href)) return;
    seen.add(href);
    const l = document.createElement("link");
    l.rel = "prefetch";
    l.href = href;
    document.head.appendChild(l);
  }
  function onIntent(e) {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    let u;
    try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin === location.origin && /\/(products|collections)\//.test(u.pathname)) prefetch(u.href);
  }
  document.addEventListener("mouseover", onIntent, { passive: true });
  document.addEventListener("touchstart", onIntent, { passive: true });
})();

// Cart drawer: swipe-down to dismiss on mobile (native bottom-sheet feel).
(function () {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;
  function bind() {
    const panel = drawer.querySelector(".drawer__inner");
    if (!panel || panel.dataset.swipeBound) return;
    panel.dataset.swipeBound = "1";
    let startY = 0, curY = 0, dragging = false;
    panel.addEventListener("touchstart", (e) => {
      if (!isMobile()) return;
      const sc = panel.querySelector(".drawer__contents, .cart-drawer-items, #CartDrawer-CartItems") || panel;
      if (sc.scrollTop > 0) return;
      startY = curY = e.touches[0].clientY; dragging = true; panel.style.transition = "none";
    }, { passive: true });
    panel.addEventListener("touchmove", (e) => {
      if (!dragging) return;
      curY = e.touches[0].clientY;
      panel.style.transform = "translateY(" + Math.max(0, curY - startY) + "px)";
    }, { passive: true });
    panel.addEventListener("touchend", () => {
      if (!dragging) return;
      dragging = false; panel.style.transition = ""; panel.style.transform = "";
      if (curY - startY > 110 && typeof drawer.close === "function") drawer.close();
    });
  }
  bind();
  // re-bind if Dawn re-renders the drawer contents
  new MutationObserver(bind).observe(drawer, { childList: true, subtree: true });
})();
